
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import './TPDSViewReport.css';
import { jsPDF } from "jspdf";  // Import jsPDF
import "jspdf-autotable";
import Select from 'react-select'; // Import react-select
import { format } from 'date-fns';
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
// import responseData from '../responsegodown.json'
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const TPDSViewReport = () => {
    const geoTaggedUids = ['215', '216', '217', '218', '219', '220', '221'];
    const questionUidToTextMap = {
        '215': '(A) Godown Front Photo',
        '216': '(B) Approach Road',
        '217': '(C) Godown Flooring',
        '218': '(D) Godown Roof',
        '219': '(E) Stacking of bags- Middle View',
        '220': '(F) Stacking of bags- Side Wall Gap',
        '221': '(G) Stacking of bags- Back Wall Gap',
        // '225': 'Signed Observations & Deviations (Photo)',
        // '229': 'Photo of Inspecting Officer at Godown'
        // Add more hardcoded entries if needed
    };
    const geoTaggedUid = ['189', '206'];
    const [dataMessage, setDataMessage] = useState('');
    const [districts, setDistricts] = useState([]);
    const [error, setError] = useState(null);  // Define setError here
    const [showDownloadPdf, setShowDownloadPdf] = useState(false);
    const reportRef = useRef(null);  // Reference to the report HTML
    const [isOpen, setIsOpen] = useState(false); // To control dropdown open/close
    const [tableData, setTableData] = useState({});
    const [panchayatName, setPanchayatName] = useState('');
    const [blockName, setBlockName] = useState('');
    const [subDivisionName, setSubDivisionName] = useState('');
    const [districtName, setDistrictName] = useState('');
    const [officerName, setOfficerName] = useState('');


    const modalRef = useRef(null);  // For the modal div
    const modalImageRef = useRef(null);  // For the modal image element
    // const captionRef = useRef(null);  // For the caption element





    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (localPath) => {
        if (modalRef.current && modalImageRef.current) {
            modalRef.current.style.display = "block";  // Show the modal
            modalImageRef.current.src = localPath;     // Set the image source
            // captionRef.current.innerHTML = localPath;  // Optionally show a caption
        }
    };

    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.style.display = "none";
        }
    };

    // Your Base64 encoded font (replace this with your actual Base64 font string)
    // const hindiWord=`${process.env.BASE_URL_HINDI}`;
    // const TiroDevanagariHindiBase64 = hindiWord;
    function capitalizeFirstTwoWords(name) {
        if (!name) return name; // Check if name exists
        const words = name.split(' ');
        if (words.length > 1) {
            words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase(); // Capitalize first word
            words[1] = words[1].charAt(0).toUpperCase() + words[1].slice(1).toLowerCase(); // Capitalize second word
        }
        return words.join(' ');
    }
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };

    const generatePDF = () => {
        // Create a new jsPDF instance
        const doc = new jsPDF();

        doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30);  // Image format: 'PNG'

        let yPosition = 45; // Starting Y position

        // Set the font to bold
        doc.setFont("helvetica", "bold");  // "helvetica" is the font, "bold" is the weight
        // doc.addFileToVFS('TiroDevanagariHindi-Regular.ttf', TiroDevanagariHindiBase64);
        // doc.addFont('TiroDevanagariHindi-Regular.ttf', 'tiroDevanagari', 'normal');  // Register the font
        doc.text("godown Inspection Report", 67, yPosition);
        yPosition += 10; // Move Y position down for next element
        let startY = 25;  // Starting Y position (distance from top of the page)
        const tableHeight = 8;  // Row height for each line
        startY += tableHeight;  // Move down for the next row
        const tableHeight2 = 8;  // Row height for each line
        startY += tableHeight - 8;  // Add some space between the two tables

        startY += tableHeight2;

        const getLastY = () => {
            return doc.lastAutoTable && doc.lastAutoTable.finalY ? doc.lastAutoTable.finalY : startY + 12.33; // Default Y position
        };

        const inspecOffFeedInfo1 = [
            ...(questionSurveys?.find(survey => survey.question?.questionUid === '226')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '226')?.question?.questionText || 'No Data',
                    formatFullName(questionSurveys.find(survey => survey.question?.questionUid === '226')?.response || 'No Response')
                ]
            ] : []),
        ];

        // Add Shop Details Section
        const shopDetailsY15 = getLastY() + 6;

        // Set background color (if needed)
        doc.setFillColor(245, 245, 245); // Gray background

        // Set text color for the header
        doc.setTextColor(12, 92, 108); // Dark Blue text
        doc.setFont('helvetica', 'bold');
        // Get current date and time
        const currentDate = new Date();
        const formattedDateAndTime = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()} ${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Loop through `inspecOffFeedInfo1` to add questionText and response dynamically
        let yPosition1 = shopDetailsY15;  // Start position for text

        inspecOffFeedInfo1.forEach((item, index) => {
            // For each question and response, add them to the PDF
            const questionText = item[0] || 'No Data';
            const response = item[1] || 'No Response';

            // Set the position dynamically
            doc.text(` ${questionText} : ${capitalizeFirstTwoWords(response)}  `, 13, yPosition1);
            yPosition += 6;  // Add some space between lines
            // Save the current font settings
            const currentFontSize = doc.internal.getFontSize();
            const currentTextColor = doc.getTextColor();

            // Set font size and color for the specific text
            doc.setTextColor(0, 0, 0)  // Set text color to black
                .setFontSize(11)         // Set font size to 11
                .text(`Report Date: ${formattedDateAndTime}`, 135, yPosition1);

            // Reset the font size and color to original values after this text
            doc.setFontSize(currentFontSize)
                .setTextColor(currentTextColor);



            yPosition += 3;  // Add space before the next question-response pair
        });

        // Define the table columns and autoTable (if needed) for your other content
        const pageWidth015 = doc.internal.pageSize.width;
        const leftMargin015 = 14;
        const rightMargin015 = 14;

        const availableWidth015 = pageWidth015 - leftMargin015 - rightMargin015;

        // Define custom column widths for the table
        const firstColumnWidth015 = availableWidth015 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth015 = availableWidth015 * 0.4; // 40% of the available width for the second column

        // Highlighting logic: Apply custom style to the row or cell you want to highlight
        doc.autoTable({
            startY: yPosition,  // Start below the section header

            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth015 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth015 }, // Second column takes 40% width
            },
            margin: { left: leftMargin015 },  // Adjust table to fit in the left margin
            didDrawCell: (data) => {
                // Highlight questionText and response cells only
                if (data.column.index === 0 || data.column.index === 1) {  // Column 0: questionText, Column 1: response
                    data.cell.styles.fillColor = [255, 255, 0]; // Yellow background for these cells
                    data.cell.styles.textColor = [0, 0, 0];    // Black text for these cells
                    data.cell.styles.fontStyle = 'bold';        // Bold text for these cells
                }
            }
        });



        // Create user information table
        const userInfo = [
            ["godown ID", godownid || "No godown ID"],
            ["District Name", capitalizeFirstLetter(district) || "No District"],
            ["Sub-Division Name", capitalizeFirstLetter(subDivision) || "No SubDivision"],
            ["Block Name", capitalizeFirstLetter(block) || "No Block"],
            ["Panchayat Name", capitalizeFirstLetter(panchayat) || "No Panchayat"]
        ];

        // Add Shop Details Section
        const shopDetailsY1 = getLastY() + 6;
        // Set background color
        doc.setFillColor(245, 245, 245); // Black background
        // Calculate text width and height
        const textWidth11 = doc.getTextWidth('SHOP DETAILS');
        const padding11 = 141;
        // Draw background rectangle
        doc.rect(14, shopDetailsY1 - 8, textWidth11 + padding11, 10, 'F');
        // Set text color
        doc.setTextColor(12, 92, 108); // White text
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('User Information', 16, shopDetailsY1);

        const pageWidth01 = doc.internal.pageSize.width;
        const leftMargin01 = 14;
        const rightMargin01 = 14;

        const availableWidth01 = pageWidth01 - leftMargin01 - rightMargin01;
        // Define custom column widths
        const firstColumnWidth01 = availableWidth01 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth01 = availableWidth01 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: shopDetailsY1 + 2,  // Start below the section header
            body: userInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth01 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth01 }, // Second column takes 40% width
            },
            margin: { left: leftMargin01 },  // Adjust table to fit in the left margin
        });
        // Add Shop Details Table
        const shopDetails = [
            // [questionSurveys?.find(survey => survey.question?.questionUid === '101')?.question?.questionText || 'No Data',
            // (questionSurveys?.find(survey => survey.question?.questionUid === '101')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '102')?.question?.questionText || 'No Data',
            // (questionSurveys?.find(survey => survey.question?.questionUid === '102')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '103')?.question?.questionText || 'No Data',
            // (questionSurveys?.find(survey => survey.question?.questionUid === '103')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '104')?.question?.questionText || 'No Data',
            // (questionSurveys?.find(survey => survey.question?.questionUid === '104')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '105')?.question?.questionText || 'No Data',
            // (questionSurveys?.find(survey => survey.question?.questionUid === '105')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '106')?.question?.questionText || 'No Data',
            // questionSurveys?.find(survey => survey.question?.questionUid === '106')?.response || 'No Response'],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '107')?.question?.questionText || 'No Data',
            // (questionSurveys?.find(survey => survey.question?.questionUid === '107')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '108')?.question?.questionText || 'No Data',
            // questionSurveys?.find(survey => survey.question?.questionUid === '108')?.response || 'No Response'],
        ];
        //  const shopDetails = [];

        for (let i = 101; i <= 113; i++) {
            if ([110, 111, 112].includes(i)) continue; // Skip missing UIDs

            const survey = questionSurveys?.find(s => s.question?.questionUid === i.toString());

            let label = survey?.question?.questionText || "No Data";
            let response = survey?.response || "No Response";

            // Handle special JSON for UID 109
            if (i === 109) {
                try {
                    const parsed = JSON.parse(response);
                    if (Array.isArray(parsed)) {
                        response = parsed
                            .map(item => `${item.godownId} - ${item.name}`)
                            .join("\n");
                    }
                } catch (e) {
                    response = "Invalid Response";
                }
            }

            shopDetails.push([label, response]);
        }


        // Add Shop Details Section
        const shopDetailsY = getLastY() + 8.4;
        // Set background color
        doc.setFillColor(245, 245, 245); // Black background
        // Calculate text width and height
        const textWidth = doc.getTextWidth('SHOP DETAILS');
        const padding = 141;
        // Draw background rectangle
        doc.rect(14, shopDetailsY - 8, textWidth + padding, 10, 'F');
        // Set text color
        doc.setTextColor(12, 92, 108); // White text
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Godown General Information', 16, shopDetailsY);


        // godown general information Done 

        // godown ShopOperation start

        const pageWidth101 = doc.internal.pageSize.width;
        const leftMargin101 = 14;
        const rightMargin101 = 14;
        const availableWidth101 = pageWidth101 - leftMargin101 - rightMargin101;
        const firstColumnWidth101 = availableWidth101 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth101 = availableWidth101 * 0.4; // 40% of the available width for the second column
        doc.autoTable({
            startY: shopDetailsY + 2,  // Start below the section header
            body: shopDetails,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth101 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth101 }, // Second column takes 40% width
            },
            margin: { left: leftMargin101 },  // Adjust table to fit in the left margin
        });
        const shopInformationY = getLastY() + 8.4;
        doc.setFillColor(245, 245, 245); // Black background
        const textWidth1 = doc.getTextWidth('SHOP INFORMATIONS');
        const padding1 = 122;
        doc.rect(14, shopInformationY - 8, textWidth1 + padding1, 10, 'F');
        doc.setTextColor(12, 92, 108); // White text
        doc.setFont('helvetica', 'bold')
        doc.text(' Godown Shop Operations', 16, shopInformationY);
        const shopInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '114')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '114')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '115')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '115')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '116')?.question?.questionText || 'No Data',
            // capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '116')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '117')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '117')?.response || 'No Response')],
        ];
        // godown Shop Operation end

        const pageWidth10 = doc.internal.pageSize.width;
        const leftMargin10 = 14;
        const rightMargin10 = 14;

        const availableWidth10 = pageWidth10 - leftMargin10 - rightMargin10;
        // Define custom column widths
        const firstColumnWidth10 = availableWidth10 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth10 = availableWidth10 * 0.4; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: shopInformationY + 2,  // Start below the section header
            body: shopInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth10 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth10 }, // Second column takes 40% width
            },
            margin: { left: leftMargin10 },  // Adjust table to fit in the left margin
        });












        // Add "Shop Stock Information" Section
        let infrastructure = getLastY() + 8.4; // gap in between the table haeader creating new table
        // Check if a new page is required
        if (infrastructure > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            infrastructure = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth4 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding4 = 104;  // heading name  background page
        // Draw background rectangle
        doc.rect(14, infrastructure - 8, textWidth4 + padding4, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Godown Infrastructure', 16, infrastructure);
        // Prepare stock information
        const questionUidToTextMap = {
            '215': '(A) Godown Front Photo',
            '216': '(B) Approach Road',
            '217': '(C) Godown Flooring',
            '218': '(D) Godown Roof',
            '219': '(E) Stacking of bags- Middle View',
            '220': '(F) Stacking of bags- Side Wall Gap',
            '221': '(G) Stacking of bags- Back Wall Gap',
            // '207': 'Storage Capacity of the Godown',
            // '208': 'Capacity Utilized',
            // '209': 'Condition of Bags',
            // '210': 'Cleanliness of Godown',
            // '211': 'Proper Stacking of Bags',
            // '212': 'Proper Aisle in Between',
            // '213': 'Any Signs of Pests/Rodents',
            // '214': 'Any Leakage or Damage Observed'
        };

        const imageUids = ['215', '216', '217', '218', '219', '220', '221'];
        const textUids = ['207', '209', '210', '211', '212', '213', '214'];

        const infrastruInfo = [];

        // Handle Images
        imageUids.forEach(uid => {
            const photo = geoTaggedPhotos?.find(p => p?.question?.questionUid === uid);
            const questionText = photo?.question?.questionText || questionUidToTextMap[uid] || 'Unknown Question';

            if (photo?.url) {
                infrastruInfo.push([questionText, getLocalImagePath(photo.url)]);
            } else {
                infrastruInfo.push([questionText, 'No Photo']);
            }
        });

        // Handle Text Responses
        textUids.forEach(uid => {
            const questionData = questionSurveys?.find(q => q?.question?.questionUid === uid);
            const questionText = questionData?.question?.questionText || questionUidToTextMap[uid] || 'Unknown Question';

            if (questionData?.response) {
                const cleaned = cleanText(questionData.response);
                infrastruInfo.push([questionText, cleaned]);
            } else {
                infrastruInfo.push([questionText, 'No Response']);
            }
        });

        // Dynamically set the table startY
        const tableStartY2 = infrastructure + 2.25;

        // Get the available width for the table (minus the left and right margins)
        const pageWidth1 = doc.internal.pageSize.width;
        const leftMargin1 = 14;
        const rightMargin1 = 14;
        const availableWidth1 = pageWidth1 - leftMargin1 - rightMargin1;

        // Define custom column widths
        const firstColumnWidth1 = availableWidth1 * 0.77;  // 60% of the available width for the first column
        const secondColumnWidth1 = availableWidth1 * 0.23; // 40% of the available width for the second column

        // Add table with 50% column widths
        doc.autoTable({
            startY: tableStartY2,  // Start below the section header
            body: infrastruInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth1 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth1 }, // Second column takes 40% width
            },
            margin: { left: leftMargin1 },  // Adjust table to fit in the left margin
            didDrawCell: function (data) {
                if (data.column.index === 1) {
                    const rowData = infrastruInfo[data.row.index]; // safer access
                    const imageURL = Array.isArray(rowData) ? rowData[1] : null;

                    if (imageURL && imageURL !== '#') {
                        try {
                            doc.addImage(imageURL, 'JPEG', data.cell.x + 1, data.cell.y + 1, 40, 30);
                            data.cell.text = [];
                            data.cell.raw = "";
                        } catch (error) {
                            console.warn('Image insert failed:', error);
                        }
                    }
                }
            }

        });
        //*********************************************************************************************** */


        // Add "Shop Stock Information" Section
        let shopStockInformationY = getLastY() + 8.4;
        // Check if a new page is required
        if (shopStockInformationY > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            shopStockInformationY = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth2 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding2 = 104;
        // Draw background rectangle
        doc.rect(14, shopStockInformationY - 8, textWidth2 + padding2, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text(' Godown Record Maintance', 16, shopStockInformationY);
        // Prepare stock information
        const stockInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '173')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '173')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '287')?.question?.questionText || 'No Data',
            // capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '208')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '174')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '174')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '175')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '175')?.response || 'No Response')],

            [questionSurveys?.find(survey => survey.question?.questionUid === '176')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '176')?.response || 'No Response')],

            [questionSurveys?.find(survey => survey.question?.questionUid === '177')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '177')?.response || 'No Response')],

            [questionSurveys?.find(survey => survey.question?.questionUid === '178')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '178')?.response || 'No Response')],

            [questionSurveys?.find(survey => survey.question?.questionUid === '179')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '179')?.url || '#')],

            [questionSurveys?.find(survey => survey.question?.questionUid === '180')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '180')?.url || '#')],

            [questionSurveys?.find(survey => survey.question?.questionUid === '181')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '181')?.url || '#')],
        ];
        // Dynamically set the table startY
        const tableStartY = shopStockInformationY + 2.25;
        // Add table
        const pageWidth11 = doc.internal.pageSize.width;
        const leftMargin11 = 14;
        const rightMargin11 = 14;

        const availableWidth11 = pageWidth11 - leftMargin11 - rightMargin11;
        // Define custom column widths
        const firstColumnWidth11 = availableWidth11 * 0.76;  // 60% of the available width for the first column
        const secondColumnWidth11 = availableWidth11 * 0.24; // 40% of the available width for the second column
        // Add table with 50% column widths
        doc.autoTable({
            startY: tableStartY,  // Start below the section header
            body: stockInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth11 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth11 }, // Second column takes 40% width
            },
            margin: { left: leftMargin11 },  // Adjust table to fit in the left margin
            didDrawCell: function (data) {
                if (data.column.index === 1) {
                    const rowData = stockInfo[data.row.index]; // safer access
                    const imageURL = Array.isArray(rowData) ? rowData[1] : null;

                    if (imageURL && imageURL !== '#') {
                        try {
                            doc.addImage(imageURL, 'JPEG', data.cell.x + 1, data.cell.y + 1, 42, 28);
                            data.cell.text = [];
                            data.cell.raw = "";
                        } catch (error) {
                            console.warn('Image insert failed:', error);
                        }
                    }
                }
            }

        });

        //****************************************************************************************************** */



        // Add "Shop Stock Information" Section
        let invenotoryVerification = getLastY() + 8.4;
        // Check if a new page is required
        if (invenotoryVerification > doc.internal.pageSize.height - 20) {
            doc.addPage();  // Add new page
            invenotoryVerification = 20;  // Reset Y position
        }
        // Set background color
        doc.setFillColor(245, 245, 245);  // Light gray background
        // Calculate text width and height
        const textWidth7 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding7 = 104;
        // Draw background rectangle
        doc.rect(14, invenotoryVerification - 8, textWidth7 + padding7, 10, 'F');
        // Set text color and font
        doc.setTextColor(12, 92, 108);  // Custom text color
        doc.setFont('helvetica', 'bold');
        // Add text
        doc.text('Godown Inventory Verification', 16, invenotoryVerification);
        // Prepare stock information
        const inveVeriInfo = [];
        for (let uid = 118; uid <= 172; uid++) {
            const question = questionSurveys?.find(survey => survey.question?.questionUid === String(uid));
            if (question) {
                const questionText = question?.question?.questionText?.replace(/ in MT /g, ' ') || 'No Data';
                inveVeriInfo.push([
                    questionText,
                    formatNumber(question?.response || 'No Response')
                ]);
            }
        }

        const tableStartY5 = invenotoryVerification + 2.25;
        // Get the available width for the table (minus the left and right margins)
        const pageWidth3 = doc.internal.pageSize.width;
        const leftMargin3 = 14;
        const rightMargin3 = 14;
        const availableWidth3 = pageWidth3 - leftMargin3 - rightMargin3;
        // Define custom column widths
        const firstColumnWidth3 = availableWidth3 * 0.6;  // 60% of the available width for the first column
        const secondColumnWidth3 = availableWidth3 * 0.4; // 40% of the available width for the second column

        // Add table with custom column widths
        doc.autoTable({
            startY: tableStartY5,  // Start below the section header
            body: inveVeriInfo,
            theme: 'grid',
            styles: { fontSize: 10.5 },
            columnStyles: {
                0: { cellWidth: firstColumnWidth3 },  // First column takes 60% width
                1: { cellWidth: secondColumnWidth3 }, // Second column takes 40% width
            },
            margin: { left: leftMargin3 },  // Adjust table to fit in the left margin
        });



        // ******************************       Godown Inventory Verification Done   ***************************************************************************




        const TiroDevanagariHindiBase64 = process.env.BASE_URL_HINDI;
        doc.addFileToVFS('TiroDevanagariHindi-Regular.ttf', TiroDevanagariHindiBase64);
        doc.addFont('TiroDevanagariHindi-Regular.ttf', 'tiroDevanagari', 'normal');
        doc.setFont('tiroDevanagari', 'normal');

        async function getImageBase64(imageUrl) {
            try {
                // Skip if already base64
                if (imageUrl.startsWith('data:image')) return imageUrl;

                const response = await fetch(imageUrl);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const blob = await response.blob();
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            } catch (error) {
                console.error('Error converting image to base64:', error);
                return null; // Return null if conversion fails
            }
        }



        // Function to check if the response is a URL that points to an image
        const isImageUrl = (str) =>
            typeof str === 'string' &&
            (str.startsWith('https://') || str.startsWith('http://') || str.startsWith('https://d2qyrr1tl2df8g'));

        // Test example
        const testStr = 'https://parakhfiles.s3.ap-south-1.amazonaws.com/sample.jpeg';

        console.log("Is image URL?", isImageUrl(testStr)); // ✅ true or false (boolean)

        // Add Beneficiary Feedback Section
        let godownSurvetAnalysis = getLastY() + 8.4; // Assuming getLastY() is a function that gets the last Y position in the document
        if (godownSurvetAnalysis > doc.internal.pageSize.height - 20) {
            doc.addPage();
            godownSurvetAnalysis = 20;
        }





        // Section Header
        doc.setFillColor(245, 245, 245);
        const textWidth8 = doc.getTextWidth('BENEFICIARY FEEDBACK');
        const padding8 = 111.5;
        doc.rect(14, godownSurvetAnalysis - 8, textWidth8 + padding8, 10, 'F');
        doc.setTextColor(12, 92, 108);
        doc.setFont('helvetica', 'bold');
        doc.text('Grain Sample Details', 16, godownSurvetAnalysis);

        // Prepare the feedback data
        const beneFeedInfo = grainSampleQuestionSurveys?.flatMap(survey =>
            survey?.grainQuestionResponseArray

                ?.map(q => {
                    return [q.questionText || "No Data", q.response || "No Response", isImageUrl(q?.response || '')];
                }) || []
        );

        // Merge both feedback and images
        const combinedFeedInfo = [...beneFeedInfo];
        console.log(beneFeedInfo);
        // Table layout configuration
        const tableStartY6 = godownSurvetAnalysis + 2.25;
        const pageWidth2 = doc.internal.pageSize.width;
        const leftMargin2 = 14;
        const rightMargin2 = 14;
        const availableWidth2 = pageWidth2 - leftMargin2 - rightMargin2;
        const firstColumnWidth2 = availableWidth2 * 0.76;
        const secondColumnWidth2 = availableWidth2 * 0.24;

        // AutoTable to display the data
        doc.autoTable({
            startY: tableStartY6,
            body: combinedFeedInfo.map(([qText, response, isImg]) => [
                { content: qText, styles: { fontStyle: 'normal' } },
                {
                    // Show local path for image URL
                    content: isImg ? getLocalImagePath(response) : response, // Show converted URL as text for images
                    raw: {
                        value: response,
                        isImage: isImg,
                        displayText: isImg ? getLocalImagePath(response) : response // Show converted URL as text
                    },
                    styles: {
                        fontStyle: 'normal',
                        font: isImg ? undefined : 'tiroDevanagari'
                    }
                }
            ]),



            theme: 'grid',
            styles: {
                fontSize: 10.5,
                font: 'tiroDevanagari'
            },
            columnStyles: {
                0: { cellWidth: firstColumnWidth2 },
                1: { cellWidth: secondColumnWidth2 }
            },
            margin: { left: leftMargin2 },
            didDrawCell: function (data) {
                if (data.column.index === 1) {
                    const cellValue = getLocalImagePath(combinedFeedInfo[data.row.index][1]); // Access the cell value
                    const isImage = getLocalImagePath(cellValue);
                    console.log('isImage:', isImage); // Debugging log
                    console.log('cellValue:', cellValue); // Debugging log

                    if (isImage && cellValue) {
                        try {
                            const imgData = cellValue ?
                                cellValue :
                                `data:image/jpeg;base64,${isImage}`;

                            doc.addImage(imgData, 'JPEG', data.cell.x + 1, data.cell.y + 1, 42, 28);
                        } catch (e) {
                            console.warn('Image insert failed:', e);
                            doc.text('Image load failed', data.cell.x + 1, data.cell.y + 10);
                        }
                    }
                }
            },


        });



        //***************************************************************************** Done *************************************************** */



        // Regular expression to check if the string contains Hindi vowels and consonants (Devanagari script)
        const isValidHindiResponse = (response) => {
            const hindiRegex = /[\u0900-\u097F]/;
            return hindiRegex.test(response);
        };

        function cleanText(text) {
            return text.replace(/[^\x20-\x7E\u0900-\u097F]/g, '');
        }

        let inspectingOfficer = getLastY() + 8.4;
        if (inspectingOfficer > doc.internal.pageSize.height - 20) {
            doc.addPage();
            inspectingOfficer = 20;
        }

        doc.setFillColor(245, 245, 245);
        const textWidth9 = doc.getTextWidth('SHOP STOCK INFORMATION');
        const padding9 = 104;
        doc.rect(14, inspectingOfficer - 8, textWidth9 + padding9, 10, 'F');
        doc.setTextColor(12, 92, 108);
        doc.setFont('helvetica', 'bold');
        doc.text('Godown Inspecting Officer Details & Observations', 16, inspectingOfficer);

        // Register Hindi font
        // const TiroDevanagariHindiBase64 = process.env.BASE_URL_HINDI;
        doc.addFileToVFS('TiroDevanagariHindi-Regular.ttf', TiroDevanagariHindiBase64);
        doc.addFont('TiroDevanagariHindi-Regular.ttf', 'tiroDevanagari', 'normal');

        // Prepare table data
        const inspecOffFeedInfo = [];

        // Always add questionUid '53'

        const q222 = questionSurveys.find(s => s.question?.questionUid === '222');
        if (q222?.response) {
            const cleanedHindiResponse = cleanText(q222.response);
            inspecOffFeedInfo.push([
                q222.question?.questionText || 'No Data',
                cleanedHindiResponse
            ]);
        }
        const q223 = questionSurveys.find(s => s.question?.questionUid === '223');
        if (q223?.response) {
            try {
                const membersArray = JSON.parse(q223.response);
                const joinedNames = membersArray.map(name => formatFullName(name)).join('\n');
                inspecOffFeedInfo.push([
                    q223.question?.questionText || 'No Data',
                    joinedNames
                ]);
            } catch (error) {
                inspecOffFeedInfo.push([
                    q223.question?.questionText || 'No Data',
                    'Invalid team data'
                ]);
            }
        }


        // Add Hindi text from questionUid: 224
        const q224 = questionSurveys.find(s => s.question?.questionUid === '224');
        if (q224?.response) {
            const cleanedHindiResponse = cleanText(q224.response);
            inspecOffFeedInfo.push([
                q224.question?.questionText || 'No Data',
                cleanedHindiResponse
            ]);
        }
        const img225 = geoTaggedPhotos.find(s => s.question?.questionUid === '225');
        if (img225?.url) {
            inspecOffFeedInfo.push([
                img225.question?.questionText || 'No Data',
                getLocalImagePath(img225.url)
            ]);
        }
        const q226 = questionSurveys.find(s => s.question?.questionUid === '226');
        if (q226?.response) {
            const cleanedHindiResponse = cleanText(q226.response);
            inspecOffFeedInfo.push([
                q226.question?.questionText || 'No Data',
                cleanedHindiResponse
            ]);
        }
        const q227 = questionSurveys.find(s => s.question?.questionUid === '227');
        if (q227?.response) {
            const cleanedHindiResponse = cleanText(q227.response);
            inspecOffFeedInfo.push([
                q227.question?.questionText || 'No Data',
                cleanedHindiResponse
            ]);
        }
        const q228 = questionSurveys.find(s => s.question?.questionUid === '228');
        if (q228?.response) {
            const cleanedHindiResponse = cleanText(q228.response);
            inspecOffFeedInfo.push([
                q228.question?.questionText || 'No Data',
                cleanedHindiResponse
            ]);
        }

        // Add geo-tagged image from questionUid: 225
        const img229 = geoTaggedPhotos.find(s => s.question?.questionUid === '229');
        if (img229?.url) {
            inspecOffFeedInfo.push([
                img229.question?.questionText || 'No Data',
                getLocalImagePath(img229.url)
            ]);
        }



        // Table rendering
        const tableStartY7 = inspectingOfficer + 2.25;
        const pageWidth = doc.internal.pageSize.width;
        const leftMargin = 14;
        const rightMargin = 14;
        const availableWidth = pageWidth - leftMargin - rightMargin;
        const firstColumnWidth = availableWidth * 0.77;
        const secondColumnWidth = availableWidth * 0.23;

        doc.autoTable({
            startY: tableStartY7,
            body: inspecOffFeedInfo,
            theme: 'grid',
            styles: {
                fontSize: 10.5,
                textColor: [64, 64, 64]
            },
            columnStyles: {
                0: { cellWidth: firstColumnWidth, textColor: [64, 64, 64] },
                1: { cellWidth: secondColumnWidth, textColor: [64, 64, 64] }
            },
            margin: { left: leftMargin },
            didDrawCell: function (data) {
                const rowData = inspecOffFeedInfo[data.row.index];
                if (!rowData || rowData.length < 2) return;

                const questionText = rowData[0];
                const cellData = rowData[1];

                // 1. Draw white background for the entire cell
                doc.setFillColor(255, 255, 255); // White background
                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F');

                // 2. Draw cell borders (to maintain grid lines)
                doc.setDrawColor(200, 200, 200); // Light gray border color
                doc.setLineWidth(0.2);
                doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);

                // Handle second column content
                if (data.column.index === 1) {
                    if (typeof cellData === 'string' && (cellData.startsWith('http') || cellData.startsWith('data:image'))) {
                        try {
                            // Add white background specifically for the image area
                            doc.setFillColor(255, 255, 255);
                            doc.rect(data.cell.x + 1, data.cell.y + 1, 40, 22, 'F');
                            doc.addImage(cellData, 'JPEG', data.cell.x + 1, data.cell.y + 1, 40, 22);

                            // Redraw borders around image area
                            doc.setDrawColor(200, 200, 200);
                            doc.rect(data.cell.x + 1, data.cell.y + 1, 40, 22);
                        } catch (error) {
                            console.error('Error adding image:', error);
                            doc.setFont('helvetica', 'normal');
                            doc.setTextColor(69, 69, 69);
                            doc.text('Image load failed', data.cell.x + 2, data.cell.y + 5);
                        }
                    } else {
                        // Handle text content
                        const isHindi = isValidHindiResponse(cellData);
                        doc.setFont(isHindi ? 'tiroDevanagari' : 'helvetica', 'normal');
                        doc.setTextColor(69, 69, 69);
                        const splitText = doc.splitTextToSize(cellData, secondColumnWidth - 4);
                        doc.text(splitText, data.cell.x + 2, data.cell.y + 5);
                    }
                }

                // Handle first column (question text)
                if (data.column.index === 0) {
                    doc.setFont('helvetica', 'normal');
                    doc.setTextColor(69, 69, 69);
                    const splitText = doc.splitTextToSize(questionText, firstColumnWidth - 4);
                    doc.text(splitText, data.cell.x + 2, data.cell.y + 5);
                }
            }

        });

        doc.save(`${godownId}_TPDS.pdf`);
        // doc.save("view")

    };


    console.log("PDF Data.... : ", generatePDF);

































    const generateExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('godown Inspection Report');
        // Title
        worksheet.mergeCells('A1:B1');
        worksheet.getCell('A1').value = 'godown Inspection Report';
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };


        worksheet.addRow([]);
        // Merging cells for header
        worksheet.mergeCells('A2:B2');
        const mainHeader17 = worksheet.getCell('A2');



        // Retrieve the question and response based on the survey data
        const questionSurvey = questionSurveys?.find(survey => survey.question?.questionUid === '55');
        const questionText = questionSurvey?.question?.questionText || 'No Data';
        const response = formatFullName(questionSurvey?.response || 'No Response');

        // Add enough spaces to push "Report Date" to the right

        mainHeader17.value = `${questionText}: ${response}`;

        // Apply styles to the merged cell (A2)
        mainHeader17.font = {
            bold: true,    // Make text bold
            size: 11,      // Set font size
        };

        // Align the text in the merged cell
        mainHeader17.alignment = {
            horizontal: 'left',  // Left align the first part (questionText: response)
            vertical: 'middle',  // Center align vertically
        };

        // Apply background color to the merged cell (A2)
        mainHeader17.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke)
        };

        // Apply color for the first part (questionText: response)
        mainHeader17.font.color = { argb: '0C5C6C' }; // Set color for the first part (dark gray)




        // Apply black color to the Report Date part
        worksheet.getCell('A2').font = {
            color: { argb: '000000' } // Set the second part (Report Date) text to black
        };
        worksheet.addRow([]);
        worksheet.mergeCells('A3:B3');
        const mainHeader18 = worksheet.getCell('B3');

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        mainHeader18.value = `Report Date: ${formattedDateTime}`;
        mainHeader18.font = {
            bold: true,    // Make text bold
            size: 11,      // Set font size
        };

        // Align the text in the merged cell
        mainHeader18.alignment = {
            horizontal: 'right',  // Left align the first part (questionText: response)
            vertical: 'middle',  // Center align vertically
        };





        // Apply black color to the Report Date part
        worksheet.getCell('B3').font = {
            color: { argb: '000000' } // Set the second part (Report Date) text to black
        };

        // Add User Information Header
        worksheet.addRow([]);
        //worksheet.addRow(['User Information']);
        // Merge cells A2 to B2 for "User Information" header
        worksheet.mergeCells('A4:B4');
        const userInfoHeader = worksheet.getCell('A4');
        userInfoHeader.value = 'User Information';
        userInfoHeader.font = { bold: true, size: 14 };
        userInfoHeader.alignment = { horizontal: 'center', vertical: 'middle' };
        userInfoHeader.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f2f2f2' } };
        userInfoHeader.font.color = { argb: '0C5C6C' };
        // Define User Information Data
        const userInfo = [
            ['godown ID', godownid || 'No godown ID'],
            ['District Name', capitalizeFirstLetter(district) || 'No District'],
            ['Sub-Division Name', capitalizeFirstLetter(subDivision) || 'No SubDivision'],
            ['Block Name', capitalizeFirstLetter(block) || 'No Block'],
            ['Panchayat Name', capitalizeFirstLetter(panchayat) || 'No Panchayat']
        ];

        // Add rows for User Information
        userInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row
            row.font = { size: 10 };
            row.alignment = { horizontal: 'left', vertical: 'middle' };

            // Apply alternating row colors or similar (optional)
            row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } };
            row.font.color = { argb: '000000' }; // Black text color

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1);
            firstCell.font = { bold: false, color: { argb: '000000' } };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2);
            secondCell.font = { color: { argb: '33bbff' } }; // Blue text color
        });


        // Add Shop Details (General Information)
        worksheet.addRow([]);
        worksheet.addRow(['General Information']);


        // Merge cells A1 to B1
        worksheet.mergeCells('A11:B11');

        // Access the merged cell (A1)
        const mainHeader = worksheet.getCell('A11');
        mainHeader.value = 'Godown General Information'; // Set the value in the merged cells

        // Apply styles to the merged cell (A1)
        mainHeader.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const shopDetails = [];
        for (let i = 101; i <= 113; i++) {
            if ([110, 111, 112].includes(i)) continue; // Skip missing UIDs
            const survey = questionSurveys?.find(s => s.question?.questionUid === i.toString());

            let label = survey?.question?.questionText || "No Data";
            let response = survey?.response || "No Response";

            // Handle special JSON for UID 109
            if (i === 109 || i === 112) {
                try {
                    const parsed = JSON.parse(response);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                        response = parsed
                            .map(item => `${item.godownId ?? 'N/A'} - ${item.name ?? 'Unnamed'}`)
                            .join("\n");
                    } else {
                        response = "No Items Found";
                    }
                } catch (e) {
                    console.error(`Failed to parse JSON for UID ${i}:`, e.message);
                    response = "Invalid Response";
                }
            }


            shopDetails.push([label, response]);
        }
        // Add rows to the sheet for Shop Details
        // Add rows for each item in shopDetails
        shopDetails.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });

        // Add Shop Information (Shop Operations)
        worksheet.addRow([]);
        worksheet.addRow(['Godown Shop Operations']);


        // Merge cells A1 to B1
        worksheet.mergeCells('A23:B22');

        // Access the merged cell (A1)
        const mainHeader1 = worksheet.getCell('A23');
        mainHeader1.value = 'Godown Shop Operation'; // Set the value in the merged cells

        // Apply styles to the merged cell (A1)
        mainHeader1.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader1.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader1.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader1.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const shopInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '114')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '114')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '115')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '115')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '117')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '117')?.response || 'No Response')],
            // [questionSurveys?.find(survey => survey.question?.questionUid === '10')?.question?.questionText || 'No Data',
            // capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '10')?.response || 'No Response')],
        ];

        // Add rows to the sheet for Shop Information

        // Add rows for each item in shopDetails
        shopInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });

        // Add Shop Stock Information (Record Maintenance)
        worksheet.addRow([]);
        worksheet.addRow(['Godown Infrastructure']);


        // Merge cells A1 to B1
        worksheet.mergeCells('A28:B28');

        // Access the merged cell (A1)
        const mainHeader2 = worksheet.getCell('A28');
        mainHeader2.value = 'Godown Infrastructure'; // Set the value in the merged cells

        // Apply styles to the merged cell (A1)
        mainHeader2.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader2.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader2.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader2.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)


        const infrastruInfo = [
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '215')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '215')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '216')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '216')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '217')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '217')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '218')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '218')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '219')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '219')?.url || '#')],

            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '220')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '220')?.url || '#')],
            [geoTaggedPhotos?.find(survey => survey.question?.questionUid === '221')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '221')?.url || '#')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '207')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '207')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '209')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '209')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '210')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '210')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '211')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '211')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '212')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '212')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '213')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '213')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '214')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '214')?.response || 'No Response')],


        ];


        // Add rows for each item in shopDetails
        infrastruInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });



        worksheet.addRow([]);
        worksheet.addRow(['Godown Record Maintenance']);

        // Merge cells A1 to B1
        worksheet.mergeCells('A46:B46');

        // Access the merged cell (A1)
        const mainHeader3 = worksheet.getCell('A46');
        mainHeader3.value = 'Godown Record Maintenance'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader3.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader3.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader3.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader3.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)




        const displayInfo = [
            [questionSurveys?.find(survey => survey.question?.questionUid === '173')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '173')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '174')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '174')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '175')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '175')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '176')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '176')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '177')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '177')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '178')?.question?.questionText || 'No Data',
            capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '178')?.response || 'No Response')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '179')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '179')?.url || '#')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '180')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '180')?.url || '#')],
            [questionSurveys?.find(survey => survey.question?.questionUid === '181')?.question?.questionText || 'No Data',
            getLocalImagePath(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '181')?.url || '#')],
        ];

        // Add rows to the sheet for Shop Stock Information


        // Add rows for each item in shopDetails
        displayInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        worksheet.addRow([]);
        worksheet.addRow(['Godown Inventory Verification']);

        // Merge cells A1 to B1
        worksheet.mergeCells('A57:B57');

        // Access the merged cell (A1)
        const mainHeader4 = worksheet.getCell('A57');
        mainHeader4.value = 'Godown Inventory Verification'; // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader4.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader4.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader4.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader4.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const inventryVerification = [];

        for (let i = 118; i <= 172; i++) {
            const question = questionSurveys?.find(survey => survey.question?.questionUid === String(i));
            if (question) {
                const questionText = question?.question?.questionText?.replace(/ in MT /g, ' ') || 'No Data';
                inventryVerification.push([
                    questionText,
                    formatNumber(question?.response || 'No Response')
                ]);
            }
        }

        // Add rows for each item in inventryVerification
        inventryVerification.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            row.font = {
                size: 10,
            };

            row.alignment = {
                horizontal: 'left',
                vertical: 'middle',
            };

            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' },
            };

            row.font.color = { argb: '000000' };

            const firstCell = worksheet.getCell(row.number, 1);
            firstCell.font = {
                color: { argb: '000000' },
            };

            const secondCell = worksheet.getCell(row.number, 2);
            secondCell.font = {
                color: { argb: '33bbff' },
            };
        });






        // Add spacer row
        worksheet.addRow([]);

        // Merge cells A69:B69 and create the header
        worksheet.mergeCells('A96:B96');
        const mainHeader6 = worksheet.getCell('A96');
        mainHeader6.value = 'Grain Sample Details';

        mainHeader6.font = {
            bold: true,
            size: 14,
            color: { argb: '0C5C6C' }
        };

        mainHeader6.alignment = {
            horizontal: 'center',
            vertical: 'middle'
        };

        mainHeader6.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' } // Light grey background
        };

        // --- Add Feedback Rows ---
        grainSampleQuestionSurveys?.forEach((survey) => {
            survey?.grainQuestionResponseArray?.forEach((q) => {
                const questionText = q.questionText || "No Data";
                const response = q.response || "No Response";

                // Determine if it's an image URL
                const isImage = typeof response === 'string' &&
                    (response.startsWith('https://') ||
                        response.startsWith('http://') ||
                        response.startsWith('https://d2qyrr1tl2df8g'));

                // Row content
                const row = worksheet.addRow([
                    questionText,
                    isImage ? 'Image URL: ' + response : response
                ]);

                // Style for entire row
                row.font = { size: 10 };
                row.alignment = { horizontal: 'left', vertical: 'middle' };
                row.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFFF' }
                };

                // Style for first cell (question text)
                const firstCell = worksheet.getCell(`A${row.number}`);
                firstCell.font = {
                    color: { argb: '000000' } // black
                };

                // Style for second cell (response or image URL)
                const secondCell = worksheet.getCell(`B${row.number}`);
                secondCell.font = {
                    color: { argb: '33bbff' } // light blue
                };

                // Optional: add actual image (if needed using worksheet.addImage)
            });
        });


        const nextRowIndex = worksheet.lastRow.number + 2;
        worksheet.addRow([]);
        worksheet.addRow(['Godown Inspecting Officer Details & Observations']);
        // Merge cells in the dynamic row (using the dynamically calculated row index)
        worksheet.mergeCells(`A${nextRowIndex}:B${nextRowIndex}`);

        // Access the merged cell (e.g., A{nextRowIndex}) and set the value
        const mainHeader9 = worksheet.getCell(`A${nextRowIndex}`);
        mainHeader9.value = 'Godown Inspecting Officer Details & Observations';   // Set the value in the merged cells

        // Apply styles to the merged cell (A23)
        mainHeader9.font = {
            bold: true,    // Make text bold
            size: 14,      // Set font size (optional: adjust as needed)
        };

        mainHeader9.alignment = {
            horizontal: 'center',  // Center align horizontally
            vertical: 'middle',    // Center align vertically
        };

        mainHeader9.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }, // Set background color (White smoke, hex: #B9D3B6)
        };

        mainHeader9.font.color = { argb: '0C5C6C' }; // Set text color to Yellow (hex: #FFFF00)



        const inspecOffFeedInfo = [
            // Checking the existence of both questionText and response, or URL
            ...(questionSurveys?.find(survey => survey.question?.questionUid === '222')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '222')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '222')?.response || 'No Response'
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '223')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '223')?.question?.questionText || 'No Data',
                    formatFullName(questionSurveys.find(survey => survey.question?.questionUid === '223')?.response || 'No Response')
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '224')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '224')?.question?.questionText || 'No Data',
                    formatFullName(questionSurveys.find(survey => survey.question?.questionUid === '224')?.response || 'No Response')
                ]
            ] : []),

            ...(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '225')?.url ? [
                [
                    geoTaggedPhotos.find(survey => survey.question?.questionUid === '225')?.question?.questionText || 'No Data',
                    getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '225')?.url || '#')
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '226')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '226')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '226')?.response || 'No Response'
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '227')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '227')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '227')?.response || 'No Response'
                ]
            ] : []),

            ...(questionSurveys?.find(survey => survey.question?.questionUid === '228')?.response ? [
                [
                    questionSurveys.find(survey => survey.question?.questionUid === '228')?.question?.questionText || 'No Data',
                    questionSurveys.find(survey => survey.question?.questionUid === '228')?.response || 'No Response'
                ]
            ] : []),

            ...(geoTaggedPhotos?.find(survey => survey.question?.questionUid === '229')?.url ? [
                [
                    geoTaggedPhotos.find(survey => survey.question?.questionUid === '229')?.question?.questionText || 'No Data',
                    getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '229')?.url || '#')
                ]
            ] : [])
        ];



        // Add rows for each item in shopDetails
        inspecOffFeedInfo.forEach(item => {
            const row = worksheet.addRow([item[0], item[1]]);

            // Apply styles to each row in shopDetails
            row.font = {
                size: 10,          // Set font size for rows (optional, adjust as needed)
            };

            row.alignment = {
                horizontal: 'left', // Left align text horizontally
                vertical: 'middle', // Center align vertically
            };

            // Apply alternating row colors or similar (optional)
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }, // Set the background to white for rows (or change color if needed)
            };

            row.font.color = { argb: '000000' }; // Black text color (hex: #000000)

            // Apply bold styling to the first column (item[0])
            const firstCell = worksheet.getCell(row.number, 1); // First column cell (column A)
            firstCell.font = {
                // bold: true,        // Make text bold
                color: { argb: '000000' }, // Black text color
            };

            // Apply blue color to the second column (item[1])
            const secondCell = worksheet.getCell(row.number, 2); // Second column cell (column B)
            secondCell.font = {
                color: { argb: '33bbff' }, // Blue text color (hex: #0000FF)
            };
        });
        // Set column width
        // Adjust column width dynamically based on content length
        worksheet.columns.forEach((column, index) => {
            let maxLength = 0;

            // Iterate over all rows in the column and find the maximum length
            worksheet.getColumn(index + 1).eachCell((cell) => {
                const cellLength = (cell.value || '').toString().length; // Get length of the cell content
                maxLength = Math.max(maxLength, cellLength); // Update max length
            });

            worksheet.getColumn(1).width = 80; // Column A
            worksheet.getColumn(2).width = 125; // Column B
        });



        // Save the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${godownId}_TPDS.xlsx`;
        // link.download = `view.xlsx`;
        link.click();
    };





    // Effect to perform actions when report becomes visible
    useEffect(() => {
        if (showDownloadPdf) {
            // This will run when the report is visible (i.e., after the button is clicked)

            // Scroll the page to the table (if you want to scroll to the table)
            if (reportRef.current) {
                reportRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            console.log("Report is now visible");
            console.log(tableData);  // You can also log or manipulate tableData here
        }
    }, [showDownloadPdf]); // Trigger effect when showDownloadPdf state changes
    // Token you provided (for testing purposes)
    // const token = '7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5';
    // const token = `${process.env.REACT_APP_AUTH_TOKEN}`;
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;  // Define the base URL
    useEffect(() => {
        console.log('Token:', token);  // Check if token is set
        if (token) {
            axios.get(`${baseUrl}/districts`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    console.log("API Response:", response.data);  // Log entire response
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {
                        setDistricts(response.data.data);  // Set the state
                        console.log("Districts State:", response.data); // Log districts state after setting it
                    } else {
                        setError("Invalid response format");
                    }
                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);







    const isImageResponse = (response) => {
        if (!response || typeof response !== "string") return false;
        return (
            response.startsWith("content://") ||
            response.startsWith("https://parakhfiles.s3") ||
            response.startsWith("https://d2qyrr1tl2df8g") ||
            response.match(/\.(jpeg|jpg|png|gif)$/i)
        );
    };



    const getLocalImagePath = (imageUrl) => {
        const externalBaseUrl = "https://parakhfiles.s3.ap-south-1.amazonaws.com"; // Your external base URL
        const localBasePath = "https://d2qyrr1tl2df8g.cloudfront.net"; // Your local folder base path

        // Log the original image URL
        console.log('Original Image URL:', imageUrl);

        // Check if the image URL starts with the external base URL
        if (imageUrl.startsWith(externalBaseUrl)) {
            // Get the relative part of the URL (remove external base URL part)
            const relativePath = imageUrl.substring(externalBaseUrl.length);

            // Create the local path by appending the relative path to the local base folder
            const localPath = localBasePath + relativePath;

            // Log the final local path
            console.log('Converted to Local Path:', localPath);

            // Return the local path for the image
            return localPath;
        }

        // If the URL doesn't match the external base URL, return it as is
        console.log('Returning original URL as local path:', imageUrl);
        return imageUrl;
    };


    const godownId = localStorage.getItem('godownId');
    const dateOfInspection = localStorage.getItem('startTime');
    const username = localStorage.getItem('username');

    console.log("username", username); // Log to verify values
    console.log("dateofisnpec", dateOfInspection);
    console.log("godownid", godownId);
    useEffect(() => {
        if (!godownId || !dateOfInspection || !username) {
            setError('Missing godown ID or Date of Inspection');
            // setLoading(false);
            return; // Exit early if missing godownId or dateOfInspection
        }
        const fetchData = async () => {
            try {
                const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
                if (!token) {
                    throw new Error('No authentication token available');
                }
                const url = `${process.env.REACT_APP_GODOWN_API_URL}/api/survey/reports/user/${username}/godown/${godownId}/date/${dateOfInspection}`;
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                // Check if the response contains data
                if (response.data && response.data.data) {
                    const data = response.data.data;
                    console.log('Response:', data);

                    setTableData(data);
                    setOfficerName(data.officerName || 'No Officer Name');
                    setPanchayatName(data.godown?.panchayat?.panchayatName || 'No Panchayat');
                    setBlockName(data.godown?.panchayat?.block?.blockName || 'No Block');
                    setSubDivisionName(data.godown?.panchayat?.block?.subDivision?.subDivisionName || 'No Sub-Division');
                    setDistrictName(data.godown?.panchayat?.block?.subDivision?.district?.districtName || 'No District');

                    setShowDownloadPdf(true);
                    setDataMessage('');
                }
                else {
                    console.error('No data found');
                    //  setShowDownloadPdf(false);  // Hide download PDF option if no data
                    setDataMessage('Data is not available');
                    //console.log(responseData)
                }
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report data');
            } finally {
                //  setLoading(false); // Set loading to false after the request is finished
            }
        };

        // Fetch the data
        fetchData();
    }, [godownId, dateOfInspection, username]); // This effect runs when godownId or dateOfInspection changes

    // useEffect(() => {
    //   const loadMockData = async () => {
    //     try {
    //       if (responseData && responseData.data) {
    //         console.log('Loaded mock data:', responseData.data);
    //         setTableData(responseData.data);
    //         setShowDownloadPdf(true);
    //         setDataMessage('');
    //       } else {
    //         console.error('Mock data is empty or invalid');
    //         setDataMessage('Data is not available');
    //       }
    //     } catch (err) {
    //       console.error('Error loading mock data:', err);
    //       setError('Error loading mock data');
    //     }
    //   };

    //   loadMockData();
    // }, []);

    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Function to filter the data based on questionUid and return the first match
    // const getFirstDataByQuestionUid = (questionUid) => {
    //     const filteredData = tableData.filter(item => item.questionUid === questionUid);
    //     return filteredData.length > 0 ? filteredData[0] : null; // Return the first item or null if no match
    // };

    // const getFirstDataByQuestionUid = (uid) => {
    //     // Ensure that tableData is an array
    //     if (Array.isArray(tableData)) {
    //         // Filter the data based on the questionUid within the questionSurveys
    //         const filteredData = tableData.filter(item => {
    //             // Check if any of the questionSurveys have a matching questionUid
    //             return item.questionSurveys.some(survey => survey.question.questionUid === uid);
    //         });

    //         // Return the first matching data, or null if no match found
    //         return filteredData.length > 0 ? filteredData[0] : null;
    //     } else {
    //         console.error("tableData is not an array:", tableData);
    //         return null;
    //     }
    // };


    const getFirstDataByQuestionUid = (uid) => {
        // Ensure that tableData is an array
        if (tableData) {
            // Filter the data based on the questionUid within the questionSurveys
            const filteredData =
                // tableData.filter(item => {
                // Check if item.questionSurveys is an array and has the required structure
                tableData.questionSurveys && tableData.questionSurveys.some(survey =>
                    survey?.question?.questionUid === uid
                );
            // });

            // Return the first matching data, or null if no match found
            return filteredData;
        } else {
            console.error("tableData is not an array or is undefined:", tableData);
            return null;
        }
    };
    // console.log(responseData);
    // Example usage:
    // const shopDetailsData = getFirstDataByQuestionUid("1");
    // const questionSurveys = shopDetailsData ? shopDetailsData.questionSurveys : [];
    // const geoTaggedPhotos = shopDetailsData ? shopDetailsData.geoTaggedPhotos : [];
    // const benQuestionSurveys = shopDetailsData ? shopDetailsData.benQuestionSurveys : [];
    // const fairPriceShop = shopDetailsData ? shopDetailsData.fairPriceShop : [];
    // const shopDetailsData = getFirstDataByQuestionUid("1");
    const questionSurveys = tableData ? tableData.questionSurveys : [];
    const geoTaggedPhotos = tableData ? tableData.geoTaggedPhotos : [];
    const grainSampleQuestionSurveys = tableData ? tableData.grainSampleQuestionSurveys : [];
    const godownid = tableData ? tableData.godownId : [];
    const district = tableData ? tableData.district : [];
    const subDivision = tableData ? tableData.subDivision : [];
    const block = tableData ? tableData.block : [];
    const panchayat = tableData ? tableData.panchayat : [];
    const formatNumber = (value) => {
        const parsedValue = parseFloat(value);

        // Check if it's a number and not NaN
        if (!isNaN(parsedValue)) {
            // If the value is very small or zero, ensure it's displayed with two decimal places
            return parsedValue.toFixed(2);
        }
        // Otherwise, return the original value (in case it's text)
        return value;
    };
    const formatNumberComa = (value) => {


        // Check if it's a number and not NaN
        if (!isNaN(value)) {
            // If the value is very small or zero, ensure it's displayed with two decimal places
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        // Otherwise, return the original value (in case it's text)
        return value;
    };
    return (
        <div className="godown-view" ref={reportRef}>
            {/* const godownId = localStorage.getItem('godownId');
    const godownId = localStorage.getItem('godownId'); */}
            {/* {dataMessage && <p style={{ textAlign: "center", color: "red" }} >No Survey Found for godown {godownId} for user with username {username} time {dateOfInspection}</p>} */}


            {/* {showDownloadPdf && ( */}
            <div className="godown-Report-table-container">

                <div className="godownReport-header-15">
                    <button onClick={generatePDF} className="insepectioncreateUser-btn">
                        DOWNLOAD PDF
                    </button>
                    <button onClick={generateExcel} className="insepectioncreateUser-btn">
                        DOWNLOAD XLSX
                    </button>
                </div>
                <table className="godown-Report-table">
                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading-user">{questionSurveys?.find(survey => survey.question?.questionUid === '226')?.question?.questionText || 'No Data'}: <strong className="red-text-3" style={{ color: "black" }}>{formatFullName(questionSurveys?.find(survey => survey.question?.questionUid === '226')?.response || 'No Response')}</strong></th>

                        </tr>

                    </thead>
                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading">User Information</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <td>
                                Godown ID: <strong className="red-text-3">{godownid || 'No godown ID'}</strong>
                            </td>
                            <td>
                                District Name: <strong className="red-text-3">{capitalizeFirstLetter(districtName)}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Sub-Division Name: <strong className="red-text-3">{capitalizeFirstLetter(subDivisionName)}</strong>
                            </td>
                            <td>
                                Block Name: <strong className="red-text-3">{capitalizeFirstLetter(blockName)}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Panchayat Name : <strong className="red-text-3">{capitalizeFirstLetter(panchayatName)}</strong>
                            </td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading">Godown General Information</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '101')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '101')?.response || 'No Response'}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '102')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '102')?.response || 'No Response'}</strong></td>
                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '103')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '103')?.response || 'No Response'}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '104')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '104')?.response || 'No Response'}</strong></td>
                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '105')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '105')?.response || 'No Response'}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '106')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '106')?.response || 'No Response'}</strong></td>
                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '107')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '107')?.response || 'No Response'}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '108')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '108')?.response || 'No Response'}</strong></td>
                        </tr>
                        <tr>
                            <td>
                                {questionSurveys?.find(survey => survey.question?.questionUid === '109')?.question?.questionText || 'No Data'}:
                                <strong className="red-text-3">
                                    {(() => {
                                        const response = questionSurveys?.find(survey => survey.question?.questionUid === '109')?.response;
                                        try {
                                            const parsed = JSON.parse(response); // safely parse the stringified JSON
                                            return parsed.map((item, index) => (
                                                <div key={index} style={{ marginBottom: '8px' }}>
                                                    <div> {item.godownId} - {item.name}</div>
                                                    {/* <div> {item.godownId}</div>
                                                    <div>name - {item.name}</div> */}
                                                </div>
                                            ));
                                        } catch (e) {
                                            return 'Invalid Response';
                                        }
                                    })()}
                                </strong>
                            </td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '113')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '113')?.response || 'No Response'}</strong></td>

                            {/* <td>{questionSurveys?.find(survey => survey.question?.questionUid === '110')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '110')?.response || 'No Response'}</strong></td> */}
                        </tr>
                        <tr>
                            {/* <td>{questionSurveys?.find(survey => survey.question?.questionUid === '111')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{questionSurveys?.find(survey => survey.question?.questionUid === '111')?.response || 'No Response'}</strong></td> */}
                            {/* <td>
                                {questionSurveys?.find(survey => survey.question?.questionUid === '112')?.question?.questionText || 'No Data'}:
                                <strong className="red-text-3">
                                    {(() => {
                                        const response = questionSurveys?.find(survey => survey.question?.questionUid === '112')?.response;
                                        try {
                                            const parsed = JSON.parse(response); // safely parse the stringified JSON
                                            return parsed.map((item, index) => (
                                                <div key={index} style={{ marginBottom: '8px' }}>
                                                    <div> {item.godownId} - {item.name}</div>
                                                   
                                                </div>
                                            ));
                                        } catch (e) {
                                            return 'Invalid Response';
                                        }
                                    })()}
                                </strong>
                            </td>  */}
                        </tr>
                        <tr>

                        </tr>
                    </tbody>
                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading">Godown Operations</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '114')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '114')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '115')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '115')?.response || 'No Response')}</strong></td>
                        </tr>
                        <tr>
                            {/* <td>{questionSurveys?.find(survey => survey.question?.questionUid === '116')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '116')?.response || 'No Response')}</strong></td> */}
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '117')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '117')?.response || 'No Response')}</strong></td>
                        </tr>
                    </tbody>

                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading"> Godown Infrastructure</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(geoTaggedUids) &&
                            geoTaggedUids
                                .map(uid => {
                                    const photo = Array.isArray(geoTaggedPhotos)
                                        ? geoTaggedPhotos.find(photo => photo?.question?.questionUid === uid)
                                        : undefined;

                                    return {
                                        uid,
                                        questionText: photo?.question?.questionText || questionUidToTextMap[uid] || 'No Question Text',
                                        url: photo?.url || null
                                    };
                                })
                                .reduce((rows, item, index, array) => {
                                    if (index % 2 === 0) {
                                        const second = array[index + 1];
                                        rows.push(
                                            <tr key={item.uid}>
                                                <td>
                                                    {item.questionText}:
                                                    <strong className="red-text-3">
                                                        {item.url ? (
                                                            <img
                                                                src={getLocalImagePath(item.url)}
                                                                alt={`Geo-tagged ${item.uid}`}
                                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                                onClick={() =>
                                                                    openModal(
                                                                        getLocalImagePath(item.url),
                                                                        `Geo-tagged ${item.uid}`
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            <span>No Photo</span>
                                                        )}
                                                    </strong>
                                                </td>
                                                {second ? (
                                                    <td>
                                                        {second.questionText}:
                                                        <strong className="red-text-3">
                                                            {second.url ? (
                                                                <img
                                                                    src={getLocalImagePath(second.url)}
                                                                    alt={`Geo-tagged ${second.uid}`}
                                                                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                                    onClick={() =>
                                                                        openModal(
                                                                            getLocalImagePath(second.url),
                                                                            `Geo-tagged ${second.uid}`
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                <span>No Photo</span>
                                                            )}
                                                        </strong>
                                                    </td>
                                                ) : (
                                                    <td>{questionSurveys?.find(survey => survey.question?.questionUid === '207')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '207')?.response || 'No Response')}</strong></td>
                                                )}

                                            </tr>
                                        );
                                    }
                                    return rows;
                                }, [])}



                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '209')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '209')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '210')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '210')?.response || 'No Response')}</strong></td>
                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '211')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '211')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '212')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '212')?.response || 'No Response')}</strong></td>
                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '213')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '213')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '214')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '214')?.response || 'No Response')}</strong></td>
                        </tr>
                        {/* <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '207')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '207')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '208')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '208')?.response || 'No Response')}</strong></td>
                        </tr> */}
                    </tbody>
                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading"> Godown Record Maintenance</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '173')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '173')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '174')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '174')?.response || 'No Response')}</strong></td>

                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '175')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '175')?.response || 'No Response')}</strong></td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '176')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '176')?.response || 'No Response')}</strong></td>
                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '177')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '177')?.response || 'No Response')}</strong></td>

                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '178')?.question?.questionText || 'No Data'}: <strong className="red-text-3">{capitalizeFirstLetter(questionSurveys?.find(survey => survey.question?.questionUid === '178')?.response || 'No Response')}</strong></td>

                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '179')?.question?.questionText || 'No Data'}:
                                <strong className="red-text-3">
                                    {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '179')?.url ?
                                        <>
                                            {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '20')?.url)} */}
                                            <img
                                                src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '179')?.url)}
                                                alt="Geo-tagged 20"
                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '179')?.url, 'Geo-tagged 20'))} />
                                        </>
                                        : '#'}
                                </strong>
                            </td>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '180')?.question?.questionText || 'No Data'}:
                                <strong className="red-text-3">
                                    {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '180')?.url ?
                                        <>
                                            {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '20')?.url)} */}
                                            <img
                                                src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '180')?.url)}
                                                alt="Geo-tagged 20"
                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '180')?.url, 'Geo-tagged 20'))} />
                                        </>
                                        : '#'}
                                </strong>
                            </td>

                        </tr>
                        <tr>
                            <td>{questionSurveys?.find(survey => survey.question?.questionUid === '181')?.question?.questionText || 'No Data'}:
                                <strong className="red-text-3">
                                    {geoTaggedPhotos?.find(survey => survey.question?.questionUid === '181')?.url ?
                                        <>
                                            {/* {console.log('Image URL:', geoTaggedPhotos.find(survey => survey.question?.questionUid === '22')?.url)} */}
                                            <img
                                                src={getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '181')?.url)}
                                                alt="Geo-tagged 20"
                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                onClick={() => openModal(getLocalImagePath(geoTaggedPhotos.find(survey => survey.question?.questionUid === '181')?.url, 'Geo-tagged 20'))} />
                                        </>
                                        : '#'}
                                </strong>
                            </td>

                        </tr>
                    </tbody>

                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading">Godown Inventory Verification</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '118');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '119');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>

                        <tr>
                            <td>
                                {
                                    (() => {
                                        const question = questionSurveys?.find(survey => survey.question?.questionUid === '120');
                                        const questionText = question?.question?.questionText?.replace(' in MT', '') || 'No Data';
                                        const response = question?.response
                                            ? formatNumber(parseFloat(question.response).toFixed(2))
                                            : '#';
                                        return (
                                            <>
                                                {questionText}:<strong className="red-text-3">{response}</strong>
                                            </>
                                        );
                                    })()
                                }
                            </td>

                            <td>
                                {
                                    (() => {
                                        const question = questionSurveys?.find(survey => survey.question?.questionUid === '121');
                                        const questionText = question?.question?.questionText?.replace(' in MT', '') || 'No Data';
                                        const response = question?.response
                                            ? formatNumber(parseFloat(question.response).toFixed(2))
                                            : '#';
                                        return (
                                            <>
                                                {questionText}:<strong className="red-text-3">{response}</strong>
                                            </>
                                        );
                                    })()
                                }
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '122');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '123');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '124');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '125');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '126');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '127');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '128');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '129');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '130');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '131');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '132');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '133');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '134');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '135');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '136');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '137');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '138');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '139');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '140');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '141');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '142');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '143');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '144');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '145');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '146');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '147');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '148');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '149');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '150');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '151');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '152');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '153');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>

                        </tr>
                        <tr>
                            <td>{(() => {
                                const survey = questionSurveys?.find(s => s.question?.questionUid === '172');
                                let questionText = survey?.question?.questionText || 'No Data';
                                const response = survey?.response;
                                // Remove " in MT" from the question text
                                questionText = questionText.replace(' in MT', '');
                                return (
                                    <>{questionText}:<strong className="red-text-3">{response ? formatNumber(parseFloat(response).toFixed(2)) : '#'}</strong></>
                                );
                            })()}
                            </td>
                        </tr>

                    </tbody>
                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading"> Grain Sample Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {grainSampleQuestionSurveys?.map((survey, index) => {
                            // Check if "Grain" response is "Wheat"
                            const isWheat = survey.grainQuestionResponseArray?.some(
                                q => q.questionText === "Grain " && q.response?.toLowerCase() === "wheat"
                            );

                            // Now filter out "Rice Type " if Grain is Wheat
                            const filteredQuestions = survey?.grainQuestionResponseArray
                                ?.filter(q => {
                                    if (
                                        isWheat &&
                                        q.questionText === "Rice Type "
                                    ) {
                                        return false; // skip Rice Type if grain is wheat
                                    }
                                    return (
                                        q?.questionText !== "Ration/Aadhar Card No" &&
                                        q?.questionText !== "Card Holder Name"
                                    );
                                });

                            // Chunk into pairs
                            const questionPairs = filteredQuestions?.reduce((acc, question, i) => {
                                if (i % 2 === 0) acc.push([question]);
                                else acc[acc.length - 1].push(question);
                                return acc;
                            }, []);

                            return (
                                <React.Fragment key={index}>
                                    {questionPairs?.map((pair, pairIndex) => (
                                        <tr key={pairIndex}>
                                            {pair.map((question, colIndex) => {
                                                const imageUrl = getLocalImagePath(question.response);
                                                const importantQuestions = ["Received from ", "Rice Type ", "Lot No ", "Grain "];
                                                const isImportant = importantQuestions.includes(question.questionText);

                                                return (
                                                    <td key={colIndex}>
                                                        {question?.questionText && (
                                                            <>
                                                                <span
                                                                    style={{
                                                                        fontWeight: isImportant ? "bold" : "normal",
                                                                        color: isImportant ? "#2a6d86" : "#555"
                                                                    }}
                                                                >
                                                                    {question.questionText}
                                                                </span>:{" "}
                                                                {isImageResponse(question.response) ? (
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt="Grain Sample"
                                                                        style={{
                                                                            maxWidth: "50px",
                                                                            maxHeight: "50px",
                                                                            float: "right"
                                                                        }}
                                                                        onClick={() =>
                                                                            openModal(imageUrl, question.questionText)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <span
                                                                        style={{
                                                                            float: "right",
                                                                            fontWeight: isImportant ? "bold" : "bold",
                                                                            color: isImportant ? "" : "rgb(18, 151, 212)"
                                                                        }}
                                                                    >
                                                                        {question.response || "No Response"}
                                                                    </span>
                                                                )}
                                                            </>
                                                        )}
                                                    </td>
                                                );
                                            })}
                                            {pair.length === 1 && <td></td>}
                                        </tr>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </tbody>



                    <thead>
                        <tr className="godownReport-table-header">
                            <th colSpan="2" className="godownheading">Godown Inspecting Officer Details & Observations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(() => {
                            const rows = [];

                            // Step 1: Collect all valid (non-empty) <td> elements
                            const cells = [];

                            // Q222 - Always shown
                            const q222 = questionSurveys?.find(s => s.question?.questionUid === '222');
                            if (q222?.response) {
                                cells.push(
                                    <td key="q222">
                                        {q222.question?.questionText || 'No Data'}:{" "}
                                        <strong className="red-text-3">{q222.response}</strong>
                                    </td>
                                );
                            }

                            // Q223 - Only if Q222 is not 'individual'
                            if (q222?.response?.toLowerCase() !== 'individual') {
                                const q223 = questionSurveys?.find(s => s.question?.questionUid === '223');
                                if (q223?.response) {
                                    try {
                                        const members = JSON.parse(q223.response);
                                        cells.push(
                                            <td key="q223">
                                                {q223.question?.questionText || 'No Data'}:{" "}
                                                <strong className="red-text-3" style={{ display: "block", whiteSpace: "pre-line" }}>
                                                    {members.map((name, i) => <div key={i}>{formatFullName(name)}</div>)}
                                                </strong>
                                            </td>
                                        );
                                    } catch {
                                        cells.push(
                                            <td key="q223">
                                                {q223.question?.questionText || 'No Data'}:{" "}
                                                <strong className="red-text-3">Invalid Response</strong>
                                            </td>
                                        );
                                    }
                                }
                            }

                            // Q224
                            const q224 = questionSurveys?.find(s => s.question?.questionUid === '224');
                            if (q224?.response) {
                                cells.push(
                                    <td key="q224">
                                        {q224.question?.questionText || 'No Data'}:{" "}
                                        <strong className="red-text-3">{q224.response}</strong>
                                    </td>
                                );
                            }

                            // Q225 Image
                            const q225 = geoTaggedPhotos?.find(s => s.question?.questionUid === '225');
                            if (q225?.url) {
                                cells.push(
                                    <td key="q225">
                                        {q225.question?.questionText || 'No Data'}:{" "}
                                        <strong className="red-text-3">
                                            <img
                                                src={getLocalImagePath(q225.url)}
                                                alt="Geo-tagged 20"
                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                onClick={() => openModal(getLocalImagePath(q225.url), q225.question?.questionText)}
                                            />
                                        </strong>
                                    </td>
                                );
                            }

                            // Q226, Q227, Q228, Q229
                            const pushSurvey = (uid, key, formatter = val => val) => {
                                const q = questionSurveys?.find(s => s.question?.questionUid === uid);
                                if (q?.response) {
                                    cells.push(
                                        <td key={key}>
                                            {q.question?.questionText || 'No Data'}:{" "}
                                            <strong className="red-text-3">{formatter(q.response)}</strong>
                                        </td>
                                    );
                                }
                            };
                            pushSurvey('226', 'q226', formatFullName);
                            pushSurvey('227', 'q227');
                            pushSurvey('228', 'q228', formatFullName);

                            const q229 = geoTaggedPhotos?.find(s => s.question?.questionUid === '229');
                            if (q229?.url) {
                                cells.push(
                                    <td key="q229">
                                        {q229.question?.questionText || 'No Data'}:{" "}
                                        <strong className="red-text-3">
                                            <img
                                                src={getLocalImagePath(q229.url)}
                                                alt="Geo-tagged 229"
                                                style={{ maxWidth: '50px', maxHeight: '50px' }}
                                                onClick={() => openModal(getLocalImagePath(q229.url), q229.question?.questionText)}
                                            />
                                        </strong>
                                    </td>
                                );
                            }

                            // Step 2: Split cells into rows of two
                            for (let i = 0; i < cells.length; i += 2) {
                                rows.push(
                                    <tr key={i / 2}>
                                        {cells[i]}
                                        {cells[i + 1] || <td></td>}
                                    </tr>
                                );
                            }

                            return rows;
                        })()}
                    </tbody>

                </table>


                <div id="imageModal" className="modal" ref={modalRef}>
                    <span className="close" onClick={closeModal}>&times;</span>
                    <img className="modal-content" ref={modalImageRef} />
                    {/* <div id="caption" ref={captionRef}></div> */}
                </div>
            </div>
            {/* )}  */}

        </div>
    );
}
export default TPDSViewReport;